module.exports = {
  WOUND_PDF: 'woundPDF',
  FPP_ASSESSMENT_DETAIL: 'assessmentDetail',
  FPP_ASSESSMENT_HISTORY: 'assessmentHistory',
};



// WEBPACK FOOTER //
// ./src/constants/exportPDFTypes.js